module.exports = __webpack_public_path__ + "static/media/22.db37a7b1.svg";